import {Modal} from "react-bootstrap";
import React from "react";

const GoogleTokenExpiredModal = ({onClose, clientId, action}) => {

    const openSettings = () => {
        const url = new URL(window.location.href).origin
        window.open(`${url}/clients/${clientId}?tab=7`, '_blank')
        onClose()
    }

    const renderText = () => {
        if(['updated', 'created'].includes(action)){
            return (
                <>
                    The event has been <b>successfully {action}</b>, but it could not be {action} for Google Calendar
                    because Google Calendar authorization token has expired. Please reconnect your Google account.
                </>
            )
        }else{
            return (
                <>
                    Google Calendar authorization token has expired, please reconnect your Google account.
                </>
            )
        }
    }

    return (
        <Modal bsSize="big" animation={false} show={true} onHide={onClose} className="heightAuto maxHeight90"
               backdrop={true}>
            <Modal.Header>
                <Modal.Title>Google Calendar Token Expired</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="padding-top-bottom-8">
                    {renderText()}
                </div>
            </Modal.Body>
            <Modal.Footer>
                {['updated', 'created'].includes(action) && (
                    <button type="button" onClick={() => openSettings()} className="btn btn-info">
                        Go to the Service Configuration Page
                    </button>
                )}
                <button type="button" onClick={() => onClose()} className="btn btn-success">
                    Ok
                </button>

            </Modal.Footer>
        </Modal>
    )
}

export default GoogleTokenExpiredModal